module.exports = __webpack_public_path__ + "img/coopcustomer.49b66575.png";